import React from "react";

import classnames from "classnames";
import isIntuit from "Intuit/isIntuit";

const SIFormTextArea = ({ className, style, input, meta: _meta, ...rest }) => {
  const classes = classnames(className, "SIFormTextArea", {
    "SIFormTextArea--intuit": isIntuit(),
    "SIFormTextArea--error-intuit": isIntuit() && _meta && _meta.touched && _meta.error !== undefined,
  });
  return <textarea className={classes} style={style} {...input} {...rest} />;
};

export default SIFormTextArea;
